import api from './api';

export const getFormDefinitions = (params = {}) => api.get('/forms', { params });
export const getFormDefinition = (formId) => api.get(`/forms/${formId}`);
export const createFormDefinition = (data) => api.post('/forms', data);
export const updateFormDefinition = (formId, data) => api.patch(`/forms/${formId}`, data);
export const publishFormDefinition = (formId) => api.post(`/forms/${formId}/publish`);
export const submitForm = (formId, data) => api.post(`/forms/${formId}/submit`, data);
export const getFormSubmissions = (formId) => api.get(`/forms/${formId}/submissions`);
